import React, { Dispatch, ReactElement } from "react";
import { RouteComponentProps, Redirect, Switch } from "react-router";
import { connect } from "react-redux";
import { User } from "oidc-client";
import { ProtectedRoute } from "../../Auth";
import {
  appPaths,
  IAppState,
  LoadingState,
  ApiRequest,
  PageTitleSetter,
  appPageTitles
} from "../../Common";
import { BreadcrumbData, breadcrumbService } from "../../Layout";
import { setPath, setBreadcrumbs } from "../../Startup/Actions/StartupActions";
import { endpoints } from "../Constants/endpoints";
import ResponseHandler from "../../App/ResponseHandler";
import { ResponseResult } from "../../Common/Models/ResponseResult";
import { Workflow } from "../Models/Workflow";
import EditWorkflowContainer from "./EditWorkflow/EditWorkflowContainer";
import { breadcrumbsMap } from "../Constants/breadcrumbsMap";
import { Role } from "../../Common/Constants/roleEnums";

type TParams = {
  code: string;
};

type StateProps = {
  path?: string;
  user?: User;
};

type DispatchProps = {
  setPath: (location: string) => void;
  setBreadcrumbs: (breadcrumbs: Promise<BreadcrumbData[]>) => void;
};

const mapStateToProps = (state: IAppState): StateProps => ({
  path: state.app.path,
  user: state.oidc.user
});

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchProps => ({
  setPath: (location: string) => dispatch(setPath(location)),
  setBreadcrumbs: (breadcrumbs: Promise<BreadcrumbData[]>) => dispatch(setBreadcrumbs(breadcrumbs))
});

class WorkflowRoutes extends React.Component<
  RouteComponentProps<TParams> & StateProps & DispatchProps
> {
  getWorkflowName = async (code?: string) => {
    let name;

    if (code && !!this.props.user) {
      await ApiRequest.fromPath(endpoints.get(code))
        .withAuthHeader()
        .get()
        .then(async response => {
          await ResponseHandler.handle(response, (result: ResponseResult<Workflow>) => {
            name = result.payload.name;
          });
        });
    }

    return name;
  };

  resolveVariable = async (key: string, variables: Map<string, string>) => {
    switch (key) {
      case ":code":
        return this.getWorkflowName(variables.get(key) || "");
      default:
        return key;
    }
  };

  setBreadcrumbs = () => {
    if (this.props.path !== this.props.location.pathname) {
      // this.props.setPath(this.props.location.pathname);

      this.props.setBreadcrumbs(
        breadcrumbService.createBreadcrumbs(
          this.props.location.pathname,
          breadcrumbsMap,
          this.resolveVariable
        )
      );
    }
  };

  render() {
    this.setBreadcrumbs();

    return (
      <>
        <PageTitleSetter title={appPageTitles.workflows} />
        <Switch>
          <ProtectedRoute exact path={appPaths.workflows.edit} component={EditWorkflowContainer} />
          <Redirect to={appPaths.notFound} />
        </Switch>
      </>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkflowRoutes);
